import { flatten, get } from 'lodash';

export const getAppPageConfig = (
  identifier,
  currentNetwork,
  appPages = null,
) => {
  let config = {};

  const getConfig = (pages) => {
    // native pages can be within submenus
    const pagesWithSubMenus = flatten(
      pages.map((page) => [page, ...(page?.submenus ?? [])]),
    ).filter(Boolean);

    return pagesWithSubMenus.find(
      (page) =>
        (page.identifier || page.menu?.identifier) === identifier ||
        (page.feature_name || page.menu?.feature_name) === identifier,
    );
  };

  if (appPages) {
    config = getConfig(appPages);
  } else {
    currentNetwork = currentNetwork || AlumniConnect.currentNetwork;

    if (currentNetwork && currentNetwork.app_pages) {
      config = getConfig(currentNetwork.app_pages);
    }
  }

  return config?.menu ?? config;
};

export const getPageTitle = ({ featureName, title, currentNetwork }) => {
  const realTitle = [title];

  currentNetwork = currentNetwork || AlumniConnect.currentNetwork;

  if (featureName) {
    realTitle.push(
      get(getAppPageConfig(featureName, currentNetwork), 'menu_name'),
    );
  }
  if (currentNetwork) {
    realTitle.push(currentNetwork.page_title);
  }

  return realTitle.filter(Boolean).join(' | ') || document.title;
};

export const getFeaturePage = (pages, featureName) =>
  pages?.find((page) => page.menu.feature_name === featureName) || {};

export const getFeatureMenuCustomName = (
  featureName,
  defaultName,
  appPages = [],
) => {
  const menu = getAppPageConfig(featureName, null, appPages);

  return menu?.custom_name ? menu.custom_name : defaultName;
};
